import React, { useMemo } from 'react';

export default function TagsSelector({ tags, selected, onToggle, onClear }) {
  const grouped = useMemo(() => tags.reduce((acc, tag) => {
    const category = tag.category || 'Uncategorised';
    acc[category] = acc[category] || [];
    acc[category].push(tag);
    return acc;
  }, {}), [tags]);

  return (
    <details className="form-group" open>
      <summary className="form-subheading">Tags</summary>
      <p className="text-muted">Choose tags to limit visibility (members only).</p>

      {Object.entries(grouped).map(([category, tagList]) => (
        <div key={category} className="form-group">
          <label>{category}</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            {tagList.map(tag => (
              <label key={tag.name} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                <input
                  type="checkbox"
                  checked={selected.includes(tag.name)}
                  onChange={() => onToggle(tag.name)}
                />
                {tag.name}
              </label>
            ))}
          </div>
        </div>
      ))}

      <label>
        <input type="checkbox" checked={selected.length === 0} onChange={onClear} />
        {' '}No Tag (Show to All Members)
      </label>
    </details>
  );
}
